import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { vehicleContext } from '../VehicleProvider';
import type { VehicleDetails } from '../../types';
import { Wrapper, Row, SpecWrapper, SpecBodyWrapper, Container } from './NonAudiOverview.styles';
import Carfax from '../Carfax';
import { Headline, Text } from '@oneaudi/unified-web-components';
import {
  SYS_SIZE_FIXED_200,
  SYS_SIZE_FIXED_800,
  SYS_SIZE_FIXED_900,
} from '@oneaudi/unified-web-common';

const NonAudiOverview: React.FC = () => {
  const { t } = useTranslation();
  const { vehicle, market } = useContext(vehicleContext);

  const { gearType, modelName, modelYear, modelMileage } = vehicle as VehicleDetails;
  const isUsedCAN = market === 'cauc';

  const specs = [
    {
      title: t('featuresAndSpecsSection.categories.nonAudiOverview.headers.make'),
      data: modelName,
    },
    {
      title: t('featuresAndSpecsSection.categories.nonAudiOverview.headers.year'),
      data: modelYear,
    },
    {
      title: t('featuresAndSpecsSection.categories.nonAudiOverview.headers.mileage'),
      data: modelMileage,
    },
    {
      title: t('featuresAndSpecsSection.categories.nonAudiOverview.headers.transmission'),
      data: gearType,
    },
  ];

  return (
    <Wrapper>
      <Container>
        <Headline
          tag="h1"
          variant={{
            order: '3',
            type: 'headline',
            weight: 'normal',
          }}
          margin={[0, 0, SYS_SIZE_FIXED_900, 0]}
        >
          {t('featuresAndSpecsSection.categories.nonAudiOverview.title')}
        </Headline>
        {specs.map((spec) => (
          <Row key={`rw-${spec.title}`}>
            <SpecWrapper>
              <Text
                margin={[SYS_SIZE_FIXED_200, 0, SYS_SIZE_FIXED_800, 0]}
                variant={{
                  order: '1',
                  type: 'copy',
                  style: 'bold',
                }}
              >
                {spec.title}
              </Text>
            </SpecWrapper>
            <SpecBodyWrapper>
              <Text
                margin={[SYS_SIZE_FIXED_200, 0, SYS_SIZE_FIXED_800, 0]}
                variant={{
                  order: '1',
                  type: 'copy',
                  style: 'normal',
                }}
              >
                {spec.data}
              </Text>
            </SpecBodyWrapper>
          </Row>
        ))}
      </Container>
      <Carfax isCanadian={isUsedCAN} vehicleHistoryReports={vehicle?.vehicleHistoryReports} />
    </Wrapper>
  );
};

export default NonAudiOverview;
